module.exports = __webpack_public_path__ + "static/EuclidTriangle-Light-WebS-a08baca8c97d7e47c930f5e80ceced91.woff";